import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React, { useMemo } from "react";
import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  minHeight: "550px",
};

// const center = {
//   lat: 22.7196,
//   lng: 75.8577,
// };

const MapBox = () => {
  const { isLoaded } = useLoadScript({
    id: "google-Box-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  });
  const centers = useMemo(
    () => [
      { lat: 23.7196, lng: 76.8577 },
      { lat: 22.719, lng: 75.857 },
      { lat: 22.7296, lng: 75.8477 },
      { lat: 21.7196, lng: 74.8577 },
    ],
    []
  );

  return (
    <Box
      sx={{
        minHeight: 600,
      }}
      component={Paper}
      elevation={0}
    >
      <Box px={3} py={2}>
        <Typography variant="h4">Active Orders</Typography>
      </Box>
      <Box>
        {!isLoaded ? (
          <Typography variant="h5">Loading...</Typography>
        ) : (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={{ lat: 22.7196, lng: 75.8577 }}
            zoom={10}
          >
          {centers.map((marks,idx)=>(
            <MarkerF key={idx} position={marks}></MarkerF>
          ))}
          </GoogleMap>
        )}
      </Box>
    </Box>
  );
};

export default MapBox;
